module.exports = "https://static.energy5.com/_next/static/images/brand9-1bda5bc8512fdfb6312e414b3aa57596.png";